module.exports = __webpack_public_path__ + "static/media/4_Suobshtenie za sait_Covid 19_2.089_ГМ_БУЛМАГ ЕАД.a1158a82.jpg";